<template>
  <header class="oa-hero">
    <div class="oa-hero__copy">
      <span class="oa-hero__eyebrow">ryd Pay Operations · Order Amendments</span>
      <h1>Update Odoo Invoice Payment</h1>
      <p>Attach or replace payment details so Odoo can complete the order invoice.</p>
      <div class="oa-hero__guidance">
        <i class="fa fa-info-circle"></i>
        <span>
          For customer, address, or vehicle corrections on an issued invoice, use
          <router-link
            to="/accounting/invoicing/invoice-modification"
            target="_blank"
            rel="noopener"
            class="oa-hero__inline-link"
          >
            Invoice Modification </router-link
          >.
        </span>
      </div>
    </div>
    <div class="oa-hero__guardrail">
      <i class="fa fa-shield"></i>
      <div>
        <strong>Operational Workflow</strong>
        <span>Review the payment and Odoo context before sending.</span>
      </div>
    </div>
  </header>
</template>

<script setup lang="ts"></script>

<style scoped>
.oa-hero {
  display: flex;
  justify-content: space-between;
  gap: 2rem;
  align-items: flex-end;
  margin-bottom: 1.5rem;
  padding: 2rem;
  border: 1px solid #b6ccfe;
  border-radius: 1.1rem;
  background:
    radial-gradient(circle at 88% 0, #dbe7ff 0, transparent 38%),
    linear-gradient(135deg, #f5f8ff, #e8efff);
  box-shadow: 0 8px 20px rgba(23, 92, 211, 0.08);
}
.oa-hero__eyebrow {
  color: #175cd3;
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}
.oa-hero h1 {
  margin: 0.4rem 0 0.5rem;
  color: #182230;
  font-size: clamp(1.8rem, 3vw, 2.5rem);
}
.oa-hero p {
  margin: 0;
  color: #667085;
  font-size: 1rem;
}
.oa-hero__guidance {
  display: flex;
  gap: 0.55rem;
  align-items: flex-start;
  margin-top: 1.25rem;
  max-width: 52rem;
  padding: 0.75rem 0.9rem;
  border: 1px solid #c7d7fe;
  border-radius: 0.6rem;
  color: #344054;
  background: rgba(255, 255, 255, 0.72);
  font-size: 0.82rem;
}
.oa-hero__guidance > i {
  color: #175cd3;
}
.oa-hero__inline-link {
  display: inline-flex;
  align-items: center;
  gap: 0.28rem;
  color: var(--theme-default);
  font-weight: 700;
  text-decoration: underline;
  text-decoration-thickness: 0.08em;
  text-underline-offset: 0.18em;
}
.oa-hero__inline-link::after {
  content: '\f08e';
  font-family: FontAwesome;
  font-size: 0.72em;
  font-weight: normal;
  line-height: 1;
}
.oa-hero__inline-link:hover,
.oa-hero__inline-link:focus {
  color: var(--theme-secondary);
  text-decoration-thickness: 0.12em;
}
.oa-hero__guardrail {
  display: flex;
  gap: 0.75rem;
  min-width: 17rem;
  padding: 1rem;
  border: 1px solid #b6ccfe;
  border-radius: 0.75rem;
  background: rgba(255, 255, 255, 0.72);
}
.oa-hero__guardrail i {
  margin-top: 0.2rem;
  color: #175cd3;
}
.oa-hero__guardrail strong,
.oa-hero__guardrail span {
  display: block;
}
.oa-hero__guardrail span {
  margin-top: 0.2rem;
  color: #667085;
  font-size: 0.78rem;
}
@media (max-width: 991px) {
  .oa-hero {
    align-items: flex-start;
    flex-direction: column;
    padding: 1.4rem;
  }
  .oa-hero__guardrail {
    width: 100%;
    min-width: 0;
  }
}
</style>
